// extracted by mini-css-extract-plugin
export default {"summary":"W2QyD","title":"KGC4T","card":"bbuyN","switch-links-container":"uEhVR","switchLinksContainer":"uEhVR"};